module.exports = __webpack_public_path__ + "img/w3_package_thin_white.baba51d2.png";